import { createRequest } from "helpers/tools";

export const deleteNotification = async (id) => {
    return await createRequest({
        suffix: `user/notifications/${id}/delete`,
        method: "delete",
        handleError: false,
    });
};
